module.exports = __webpack_public_path__ + "static/media/border-icon-white.790305f1.svg";